import { metricValue, type FleetMetricEnvelope } from "../../../api/mcp";
import { Bars } from "../../../components/charts";
import { ResourceView } from "../../../components/states";
import { Card, Notice } from "../../../components/ui";
import type { Resource } from "../../../hooks/useResource";
import { ProductTag } from "../../../products/PerProduct";

/** Which tools are actually being spent against, right now — not a config. */
export function TopToolsToday({
  state,
  onRetry,
}: {
  state: Resource<FleetMetricEnvelope<"top_tools_today">>;
  onRetry: () => void;
}) {
  const rows = metricValue(state);

  return (
    <Card title="Top tools today" note="By credits spent · UTC day" aside={<ProductTag id="mcp" />}>
      <ResourceView state={state} what="top tools" onRetry={onRetry}>
        {() =>
          rows && rows.length > 0 ? (
            <Bars
              rows={rows.map((r) => ({
                label: r.tool,
                value: r.credits,
                note: `${r.credits} credits`,
                tone: "brand" as const,
              }))}
              max={Math.max(...rows.map((r) => r.credits))}
            />
          ) : (
            <Notice title="No spend yet today">Nothing has been billed since UTC midnight.</Notice>
          )
        }
      </ResourceView>
    </Card>
  );
}
